export default __webpack_public_path__ + "static/media/5.91ee33c7.jpg";